import type { TCertificateCardProps } from "@organisms/CertificateCard/types";

export const allCertificates: TCertificateCardProps[] = [
  {
    image: {
      src: "/static/certificates/iso-iec-27701.svg",
      alt: "iso-iec-27701-icon",
    },
    title: "ISO 27001 / 27017 / 27018",
    description:
      "Certificação ISO/IEC 27001:2013 e ISMS (Sistema de Gestão de Segurança da Informação) relacionados à segurança da informação para serviços em nuvem.",
  },
  {
    image: {
      src: "/static/certificates/iso-27701.svg",
      alt: "iso-27701-icon",
    },
    title: "ISO 27701",
    description:
      "Certificação ISO/IEC 27701:2019 e PIMS (Sistema de Gestão de Informações de Privacidade) relacionados à gestão da segurança no processamento de dados pessoais.",
  },
  {
    image: {
      src: "/static/certificates/soc-2.svg",
      alt: "soc-2-icon",
    },
    title: "SSAE 18 Type 2 SOC 1, SOC 2 + NIST, and SOC 3 Attestations",
    description:
      "Certificação da AICPA SSAE 16/ISAE 3402 Tipo 2, para controle sobre relatórios financeiros.",
  },
  {
    image: {
      src: "/static/certificates/csa-star.svg",
      alt: "csa-star-icon",
    },
    title: "CSA STAR",
    description:
      "Aliança de Segurança em Nuvem (CSA) — Avaliação de Autoconformidade no programa Security Trust Assurance Risk (STAR).",
  },
  {
    image: {
      src: "/static/certificates/hipaa.svg",
      alt: "hipaa-icon",
    },
    title: "HIPAA",
    description:
      "Conformidade com a Lei de Portabilidade e Responsabilidade de Seguros de Saúde (HIPAA) dos Estados Unidos, nos nossos data centers localizados nos EUA.",
  },
  {
    image: {
      src: "/static/certificates/pci-dss.svg",
      alt: "pci-dss-icon",
    },
    title: "PCI DSS",
    description:
      "Certificação PCI DSS Nível 1 (Padrão de Segurança de Dados da Indústria de Cartões de Pagamento), relacionada à hospedagem segura de dados de pagamento.",
  },
];
